export const removeFieldsFromArray = (exclusions, fields, keyFormat) => {
  let excludedKeys = exclusions
  if (keyFormat)
    excludedKeys = exclusions.concat(
      exclusions.map(e => keyFormat.replace('{}', e))
    )
  return fields.filter(f => !excludedKeys.includes(f.name))
}
